// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePanelLeftOpen as RawLucidePanelLeftOpen } from "lucide-react";
export const LucidePanelLeftOpen = /* @__PURE__ */ createIcon(RawLucidePanelLeftOpen, "LucidePanelLeftOpen", 2);
